import React from 'react';
import './GlassCard.css';

const GlassCard = ({ children, className = '', glow = false, onClick }) => {
  return (
    <div 
      className={`glass-card ${glow ? 'glass-card-glow' : ''} ${className}`}
      onClick={onClick}
      style={{ cursor: onClick ? 'pointer' : 'default' }}
    >
      {children}
    </div>
  );
};

export default GlassCard;